/* globals console, module, require */
/* jshint esversion:6, globalstrict:true */
'use strict';

const configuration = require('./configuration');

///
/// Module to handle reporting to Google Analytics.
/// Dynamically load the Analytics code module.
/// Handle side-by-side reporting of Universal Analytics (UA) and Google Analytics 4 (GA4) properties.
///

const _makeUserProperties = function(data) {
    return {
        wid_org: data.org || 'NONE',
        wid_roles: (data.roles && data.roles.length > 0 ? '|' + data.roles.join('|') + '|' : '||')
    };
}

let loaded = false,
    lastPageView = '';

module.exports = {
    initialize: function() {
        // initialize just sets up global gtag function and dataLayer queue.
        // calls to page_view and event are safe! data just piles up in the queue until the code loads.
        if (!window.gtag) {
            // console.log('googleAnalytics.initialize');
            // tee up basic configuration
            window.dataLayer = window.dataLayer || [];
            window.gtag = function() {dataLayer.push(arguments);}
            window.gtag('js', new Date());
        }
    },
    load: function (data) {
        // dynamically load Google Tag Manager, once we have context from the caller.
        // data expects:
        // {
        //      gaClientId      // UA tracking ID, format UA-xxxxxx
        //      measurementId   // GA4 measurementId, format GA-xxxxxx
        //      org             // user's registered organization affiliation
        //      roles           // array of logged-on user's roles
        // }
        if (!loaded) { // we'll only do this once.
            // console.log('googleAnalytics.load');
            // console.log(data);

            // Side-by-side UA tracking code
            var uaTrackingId = data.gaClientId,
                measurementId = data.measurementId,
                loadingId = (measurementId || uaTrackingId),
                cfg = {'cookie_flags': 'SameSite=None; Secure', 'send_page_view': false };	// GA4 spelling of cookie_flags; defer page_view to navigation time.

            if (uaTrackingId && uaTrackingId.length > 0 && uaTrackingId.startsWith('UA')) {
                cfg.cookieFlags = cfg.cookie_flags;	// UA spelling

                // custom map setup.
                window.gtag('set', { customMap: {'dimension1': 'wid_org', 'dimension2': 'wid_roles'} });
                // UA config call.
                // console.log(`window.gtag('config', ${uaTrackingId}, ${JSON.stringify(cfg)})`);
                window.gtag('config', uaTrackingId, cfg);
            }
            // GA4 setup.
            // console.log('measurementId: ' + measurementId + '; loadingId: ' + loadingId);
            if (measurementId && measurementId.length > 0 && measurementId.startsWith('G')) {
                // console.log(`window.gtag('config', ${measurementId}, ${JSON.stringify(cfg)})`);
                window.gtag('config', measurementId, cfg);
            }

            // console.log(`datalayer: ${JSON.stringify(window.dataLayer)}`);

            // Now trigger the dynamic load of Tag Manager.
            const s = document.createElement('script');
            s.setAttribute('src', 'https://www.googletagmanager.com/gtag/js?id=' + loadingId);
            s.async = true;
            document.head.appendChild(s);
            loaded = true;
        }
        module.exports.user(data);    // update user_properties with 'set'
    },
    pageview: function(page, name) {
        // send message to Google Analytics
        if (page === lastPageView)
            return; // avoid double-reporting page view

        var route = configuration.gaBaseRoute + '/' + page;
        route = route.replace('//', '/');
        // console.log('Tracking pageview: ' + route);
        if (window.gtag) {
            var pageTitle = name || '';
            window.gtag('event', 'page_view', {
                'page_path': route,
                'page_title': pageTitle,
                'page_location': window.location.origin + route
            });
            lastPageView = page;
        } else {
            console.warn('googleAnalytics.pageview called before initialized');
        }
    },
    event: function (category, action, label, value) {
		// send custom event to Google Analytics
		// console.log('Tracking event: ' + category + '/' + action + '/' + label + '/' + value);
		if (window.gtag) {
			// there's a GA4 or UA tracking property present. Note: 'event_category', 'event_label' and 'value' must be registered in a GA4 property.
			// Code follows efw.trackEvents.js
			let payload = { 'event_category': category };
			if (label) payload['event_label'] = label;
			if (value && -1 !== value) payload['value'] = value;
			// console.log('sending event ' + action + '({' + JSON.stringify(payload) + '})');
			window.gtag('event', action, payload);
		} else {
            console.warn('googleAnalytics.event called before initialized');
        }
	},
    user: function(data) {
        if (window.gtag) {
            let user_properties = _makeUserProperties(data);
            // console.log(`set, 'user_properties', ${JSON.stringify(user_properties)}`);
            window.gtag('set', user_properties);                    // set at top level for UA
            window.gtag('set', 'user_properties', user_properties); // set user_properties object for GA4
        }
    }
};
